export default {
  title: "Dashboard",
  welcome: "Welcome",
  overview: "Overview",
  statistics: "Statistics",
  recentActivity: "Recent Activity",
  quickActions: "Quick Actions",
  dashboard: "Dashboard",
  dashboardSubtitle: "Comprehensive overview of company performance",
  refreshData: "Refresh Data",
  lastUpdated: "Last updated",
  errorLoadingData: "Error loading data",
  retry: "Retry",
  loadingData: "Loading dashboard data...",
  gatheringInfo: "We are gathering the latest information for you",
  statisticsTitle: "Key Statistics",
  statisticsSubtitle: "Quick overview of important indicators",
  todayTasks: "Today's Routine Tasks",
  reported: "Reported",
  task: "Tasks",
  totalTasks: "Total Tasks",
  done: "Done",
  notDone: "Not Done",
  notReported: "Not Reported",
  viewDetails: "View details",
  oneTimeTasks: "One-Time Tasks",
  urgent: "Urgent",
  openTasks: "Open Tasks",
  inProgress: "In Progress",
  review: "Review",
  dueToday: "Due Today",
  dueSoon: "Due Soon",
  overdue: "Overdue",
  projects: "Projects",
  active: "Active",
  stopped: "Stopped",
  inActive: "Inactive",
  employees: "Employees",
  pending: "Pending",
  performanceTrends: "Performance Trends",
  performanceTrendsSubtitle: "Open, Review and Done over time",
  aiAnalysis: "AI Analysis",
  aiAnalysisTitle: "AI Company Performance Analysis",
  aiAnalysisSubtitle:
    "Comprehensive data analysis using artificial intelligence",
  refresh: "Refresh",
  analyzingLatestData: "Analyzing Latest Data...",
  gatheringInsights: "Gathering intelligent insights from your data",
  lastAnalyzed: "Last analyzed",
  close: "Close",
  reanalyze: "Re-analyze",
  quickAddTask: "Quick Add",
  quickAddRoutineTask: "Quick Add Routine Task",
  quickAddOneTimeTask: "Quick Add One-Time Task",
  taskName: "Task Name",
  description: "Description",
  assignTo: "Assign To",
  selectAssignee: "Select Assignee",
  selectDepartment: "Select Department",
  selectTaskType: "Select Task Type",
  selectPriority: "Select Priority",
  selectProject: "Select Project",
  startDate: "Start Date",
  endDate: "End Date",
  deadline: "Deadline",
  priority: "Priority",
  project: "Project",
  taskType: "Task Type",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  high: "High",
  normal: "Normal",
  medium: "Medium",
  low: "Low",
  cancel: "Cancel",
  create: "Create",
  saving: "Saving...",
  fillRequiredFields: "Please fill all required fields",
  validationError: "Validation Error",
  success: "Success",
  error: "Error",
  routineTaskAdded: "Routine task added successfully",
  oneTimeTaskAdded: "One-time task added successfully",
  routineTaskAddedError: "Error adding routine task",
  oneTimeTaskAddedError: "Error adding one-time task",
  enterTaskName: "Enter task name",
  enterDescription: "Enter description",
  searchEmployees: "Search Employees",
  searchProjects: "Search Projects",
  clickToAddPeople: "Click to add Employees",
  clickToEdit: "Click to edit",
  lastDayOfMonth: "Last Day of Month",
  selectLastDayOfMonth: "Select Last Day of Month",
  selectDays: "Select Days",
  selectDaysOfWeek: "Select Days of Week",
  dayOfMonth: "Day of Month",
  selectDayOfMonth: "Select Day of Month",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  scrollToSeeMore: "Swipe to see more",
  from: "From",
  to: "To",
  enterStartDate: "Enter start date",
  enterEndDate: "Enter end date",
  selectSupervisor: "Select Supervisor",
  selectInformer: "Select Informer",
  selectConsultant: "Select Consultant",
  searchPriorities: "Search Priorities",
  noResultsFound: "No results found",
  taskProgressByDept: "Task Progress by Department",
  taskProgressSubtitle: "Comparison of completed and incomplete tasks",
  reportsStatus: "Reports Status",
  reportsStatusSubtitle: "Reported and unreported tasks",
  undefined: "Undefined",
  // Charts section
  chartsTitle: "Charts and Analytics",
  chartsSubtitle: "Visual representation of department and task performance",
  // Tables section
  tablesTitle: "Detailed Data",
  tablesSubtitle: "Task and employee details by department",
  dailyTasksByDept: "Daily Tasks by Department",
  dailyTasksSubtitle: "Performance breakdown for each department",
  employeesByDept: "Employees by Department",
  employeesSubtitle: "Employee distribution across departments",
  // Table headers
  department: "Department",
  reportedTasks: "Reported",
  notReportedTasks: "Not Reported",
  completionRate: "Completion Rate",
  count: "Count",
  // Navigation buttons
  prevChart: "Prev",
  nextChart: "Next",
  clickToViewRoutineTasks: "Click to view Routine Tasks",
  clickToViewOneTimeTasks: "Click to view One-Time Tasks",
  clickToViewProjects: "Click to view Projects",
  clickToViewTeam: "Click to view Team/Employees",
  // Status
  stable: "Stable",
  charts: {
    performance: "Performance Chart",
    tasks: "Tasks Chart",
    projects: "Projects Chart",
    users: "Users Chart",
  },
  cards: {
    totalTasks: "Total Tasks",
    completedTasks: "Completed Tasks",
    pendingTasks: "Pending Tasks",
    totalProjects: "Total Projects",
    activeProjects: "Active Projects",
    totalUsers: "Total Users",
    activeUsers: "Active Users",
  },
};
